import { render, staticRenderFns } from "./patent.vue?vue&type=template&id=f2355b84&"
import script from "./patent.vue?vue&type=script&lang=js&"
export * from "./patent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports